import { useState } from 'react'

interface SearchFormProps {
  onSearch: (query: string) => void
  isLoading?: boolean
  placeholder?: string
  initialValue?: string
  className?: string
  compact?: boolean
}

export default function SearchForm({ 
  onSearch, 
  isLoading = false, 
  placeholder = "Ask a question about web specs...",
  initialValue = "",
  className = "",
  compact = false
}: SearchFormProps) {
  const [query, setQuery] = useState(initialValue)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (query.trim() && !isLoading) {
      onSearch(query)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      if (e.shiftKey) {
        // Shift+Enter: allow newline (default behavior)
        return
      } else {
        // Enter: submit search
        e.preventDefault()
        handleSubmit(e as any)
      }
    }
  }

  if (compact) {
    return (
      <form onSubmit={handleSubmit} className={`flex space-x-2 ${className}`}>
        <textarea
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
          rows={1}
          disabled={isLoading}
        />
        
        <button
          type="submit"
          disabled={!query.trim() || isLoading}
          className="px-4 py-2 bg-primary-600 text-white text-sm font-medium rounded hover:bg-primary-700 focus:ring-1 focus:ring-primary-500 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isLoading ? '...' : 'Search'}
        </button>
      </form>
    )
  }

  return (
    <form onSubmit={handleSubmit} className={`w-full max-w-2xl mx-auto ${className}`}>
      <div className="flex flex-col items-center space-y-4">
        <textarea
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className="w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
          rows={5}
          disabled={isLoading}
        />
        
        <button
          type="submit"
          disabled={!query.trim() || isLoading}
          className="px-6 py-3 bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isLoading ? 'searching...' : 'search web specs'}
        </button>
      </div>
    </form>
  )
}
